import { render, staticRenderFns } from "./GridChannelList.vue?vue&type=template&id=0f4791e0&scoped=true&"
import script from "./GridChannelList.vue?vue&type=script&lang=js&"
export * from "./GridChannelList.vue?vue&type=script&lang=js&"
import style0 from "./GridChannelList.vue?vue&type=style&index=0&id=0f4791e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4791e0",
  null
  
)

export default component.exports